export interface MultiSelectFilter {
  attr: string;
  type: 'multi_select' | 'nights';
  options: MultiSelectOption[];
}

interface MultiSelectOption {
  [key: string]: string;
}

export interface NumericRangeFilter {
  attr: string;
  type: 'numeric_range';
  min: number;
  max: number;
  unit: string;
  adjusted_min_label?: number;
  adjusted_max_label?: number;
}

export interface StarsFilter {
  attr: string;
  type: 'stars';
  options: { id: number; min: string }[];
}

export interface Feature {
  attr: string;
  type: 'feature';
  options: { id: string; min: string }[];
}

export interface HoursFilter {
  attr: string;
  type: 'hours';
}
export interface BooleanFilter {
  attr: string;
  type: 'boolean';
}

export interface NameFilter {
  attr: string;
  type: 'free_text';
}

export enum AttractionsSortBy {
  RECOMMENDED = 'recommended',
  PRICE = 'price',
}

export interface SortBy {
  attr: string;
  // attr: 'sortBy';
  type: 'select_one';
  // options: AttractionsSortBy[];
  options: string[] | { id: number | string; name: string }[];
}

export interface TreeFilter {
  attr: string;
  type: 'tree';
  // attr: 'taxonomy';
  options: MultiSelectOption[];
}

export enum SideFilterType {
  MultiSelect = 'multi_select',
  NumericRange = 'numeric_range',
  Stars = 'stars',
  Hours = 'hours',
  Nights = 'nights',
  Boolean = 'boolean',
  Tree = 'tree',
  FreeText = 'free_text',
  SelectOne = 'select_one',
}

export enum SideFilterAttr {
  Feature = 'feature',
  Airline = 'airline',
  Hotel = 'hotel',
  HotelType = 'hotel_type',
  hotelStars = 'hotel_stars',
  FreeCancellation = 'freeCancellation',
  TsType = 'ts_type',
  BoardBasis = 'boardBasis',
  Stops = 'stops',
  Price = 'price',
  AutoApprove = 'auto_approve',
  IncludeTransfer = 'include_transfer',
  IncludeBaggage = 'include_baggage',
  IncludeTrolly = 'include_trolly',

  FromDateHours = 'from_date_hours',
  FromDateLandingHours = 'from_date_landing_hours',
  ReturnDateHours = 'return_date_hours',
  ReturnDateLandingHours = 'return_date_landing_hours',
  FlightStopTime = 'flight_stop_time',
  Taxonomies = 'taxonomy',
  // and more TBD...
}

export type OptionalFilter =
  | NumericRangeFilter
  | StarsFilter
  | Feature
  | MultiSelectFilter
  | BooleanFilter
  | TreeFilter
  | NameFilter
  | HoursFilter
  | SortBy;

export interface Filters {
  optional_filters: OptionalFilter[];
}
